<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>This book is dedicated to my extended family past and present, particularly to my wife, Suzanne; children, Annabel and Iain; and grandchildren, Matthew, James, Joshua, and Kate; plus Joan and David McKelvey.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?d6349698